import SectionHeading from "@/components/base/SectionHeading";
import { visionMission } from "@/mocks/home";

const valuesWheel =
  "/uploads/values-wheel.jpeg";

export default function ValuesSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Who We Are"
          title="Our Vision, Mission &amp; Core Values"
          subtitle="Everything we do is driven by a commitment to safe, honest and dependable relocation for every customer."
        />

        <div className="mt-10 grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
          <div className="flex items-center justify-center rounded-lg border border-background-200 bg-background-100 p-6 md:p-10">
            <img
              src={valuesWheel}
              alt="Lahari Packers and Movers core values - Customer Focus, Collaboration, Excellence, Safety, Integrity and Respect"
              title="Our core values - Lahari Packers and Movers"
              className="mx-auto w-full max-w-md"
            />
          </div>

          <div className="grid grid-cols-1 gap-5">
            {visionMission.map((item, index) => (
              <div
                key={item.title}
                className={`flex items-start gap-4 rounded-lg border p-5 md:p-6 ${
                  index === 1 ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-50"
                }`}
              >
                {item.image ? (
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center">
                    <img
                      src={item.image}
                      alt={`${item.title} - Lahari Packers and Movers`}
                      title={`${item.title} - Lahari Packers and Movers`}
                      className="h-14 w-14 object-contain"
                    />
                  </span>
                ) : (
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-2xl`} aria-hidden="true" />
                  </span>
                )}
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}